export interface WaitForAccessTokenOptions {
  intervalMs?: number;
  timeoutMs?: number;
}

/** Polls until the API token getter has a JWT, so SignalR never negotiates anonymously. */
export async function waitForAccessToken(
  getToken: () => string | null,
  options: WaitForAccessTokenOptions = {}
): Promise<string> {
  const intervalMs = options.intervalMs ?? 50;
  const timeoutMs = options.timeoutMs ?? 10_000;
  const startedAt = Date.now();

  for (;;) {
    const token = getToken();
    if (token) {
      return token;
    }

    if (Date.now() - startedAt >= timeoutMs) {
      throw new Error('Notification hub timed out waiting for an access token');
    }

    await new Promise<void>((resolve) => {
      setTimeout(resolve, intervalMs);
    });
  }
}
